
export default {
  name: "LogoAcademy"
}
